import { useState, useEffect } from 'react';
import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
  Box,
  Typography,
} from "@mui/material";


export default function CareerDescriptionDialog({ isOpen, closeDialog, updateCareerDescription, career, careerIndex }) {
  const [careerDescription, setCareerDescription] = useState('');

  const close = async () => {
    setCareerDescription('');
    closeDialog();
  };

  const modify = async () => {
    updateCareerDescription({
      index: careerIndex,
      description: careerDescription,
    })
    close();
  }

  useEffect(() => {
    const initialize = async () => {
      try {
        setCareerDescription(career?.description || '');
      } catch (err) {
        console.error(err);
      }
    };

    if(isOpen) initialize();
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onClose={close} fullWidth maxWidth="sm">
      <>
      <DialogTitle sx={{ mb: 1 }}>
        경력 설명
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={careerDescription}
            onChange={(e) => setCareerDescription(e.target.value)}
          />
          <Box sx={{ width: 1, textAlign: "end" }}>
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              {careerDescription?.length === 0 ? "2000자 이내" : `${careerDescription?.length}/2000`}
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          sx={{ px: 6 }}
          variant="contained"
          onClick={modify}
          size="large"
          disabled={careerDescription?.length > 2000}
        >
          저장하기
        </LoadingButton>
      </DialogActions>
      </>
    </Dialog>
  )
}